/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：686__part-0
 */

"use strict"

var r = {
  "zh-CN": {
    widgetName: "对话框",
    style: "风格选择",
    styleA: "风格A",
    styleB: "风格B",
    themeColor: "主题色",
    previewImage: "预览效果",
    title: "标题",
    text: "文本",
    image: "图片",
    selectedOption: "选择结果",
    inputText: "输入内容",
    message: "弹出消息",
    select: "进行选择",
    prompt: "进行输入",
    setTitle: "标题为",
    setText: "文本为",
    setButtonText: "按钮为",
    setImage: "图片为",
    setShowCancelButton: "能否取消",
    setOption1: "选项1为",
    setOption2: "选项2为",
    setInputPlaceHolder: "提示文案为",
    onClickButton: "点击按钮",
    onSelectOption: "完成选择",
    onCancelSelection: "取消选择",
    onFinishInput: "完成输入",
    onCancelInput: "取消输入",
    buttonText: "按钮文案"
  }
}
export { r }
